// Etap 2 quizu predyspozycji: na urządzeniach dotykowych pozwala ocenić stwierdzenie
// gestem swipe (w prawo = TAK, w lewo = NIE). Na desktopie/bez dotyku działają dwa
// sąsiadujące przyciski (to baza — formularz POST-uje agree=1/0 także bez JS).
export function SwipeCard() {
    document.addEventListener('DOMContentLoaded', () => {
        const forms = document.querySelectorAll('form[data-swipe-card]');
        if (!forms.length) return;

        const isTouch = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;

        forms.forEach((form) => {
            const surface = form.querySelector('[data-swipe-card-surface]');
            const hint = form.querySelector('[data-swipe-hint]');
            if (!surface) return;

            // Submituje formularz z wybraną odpowiedzią (1 = zgadzam się, 0 = nie).
            const submitWith = (agree) => {
                if (form.dataset.swipeSubmitted === '1') return;
                form.dataset.swipeSubmitted = '1';

                const field = document.createElement('input');
                field.type = 'hidden';
                field.name = 'agree';
                field.value = agree ? '1' : '0';
                form.appendChild(field);
                form.requestSubmit ? form.requestSubmit() : form.submit();
            };

            if (!isTouch) return; // desktop: zostają same przyciski

            form.classList.add('is-swipe-enabled');
            if (hint) hint.hidden = false;

            // Mobile: oprócz gestu swipe zostawiamy widoczne przyciski TAK/NIE
            // (oba sposoby oceny działają równolegle).

            const threshold = 80;
            let startX = null;
            let deltaX = 0;

            const onStart = (event) => {
                startX = event.touches[0].clientX;
                deltaX = 0;
                surface.style.transition = 'none';
            };

            const onMove = (event) => {
                if (startX === null) return;
                deltaX = event.touches[0].clientX - startX;
                surface.style.transform = `translateX(${deltaX}px) rotate(${deltaX / 20}deg)`;
            };

            const onEnd = () => {
                if (startX === null) return;
                surface.style.transition = '';

                if (Math.abs(deltaX) >= threshold) {
                    const agree = deltaX > 0;
                    surface.style.transform = `translateX(${agree ? 1 : -1}00%) rotate(${agree ? 1 : -1}5deg)`;
                    submitWith(agree);
                } else {
                    surface.style.transform = '';
                }
                startX = null;
            };

            surface.addEventListener('touchstart', onStart, { passive: true });
            surface.addEventListener('touchmove', onMove, { passive: true });
            surface.addEventListener('touchend', onEnd);
        });
    });
}
